import React, { useState } from "react";
import RegisterUser from "../RegiserUser/index";
import AutoSamplete from "../AutoSamplete";
import TrafficLights from "../TrafficLights";

import Header from "../Header/index";

import { Link } from "react-router-dom";

function LandingPage() {
  const [formData, setFormData] = useState(null);

  const formSubmission = values => {
    if (values.email && values.location && values.name) {
      setFormData(values);
    } else {
      alert("please fill out all the fields");
    }
  };

  return (
    <div>
      <TrafficLights />
      <AutoSamplete />
      <div>
        pure dummy text goes here pure dummy text goes here pure dummy text goes
        here pure dummy text goes here pure dummy text goes here pure dummy text
        goes here pure dummy text goes here pure dummy text goes here
        <Link to="/contracts">
          <button> Contracts </button>
        </Link>
      </div>
      <div>
        pure dummy text goes here pure dummy text goes here pure dummy text goes
        here pure dummy text goes here pure dummy text goes here pure dummy text
        goes here pure dummy text goes here pure dummy text goes here
        <Link to="/providers">
          <button> Providers </button>
        </Link>
      </div>
      <div>
        pure dummy text goes here pure dummy text goes here pure dummy text goes
        here pure dummy text goes here pure dummy text goes here pure dummy text
        goes here pure dummy text goes here pure dummy text goes here
        <Link to="/dash">
          <button> Pending Contracts </button>
        </Link>
      </div>
      <link
        href="https://fonts.googleapis.com/css?family=Montserrat&display=swap"
        rel="stylesheet"
      ></link>
      <Header />
    </div>
  );
}

export default LandingPage;
